import { styled } from '@mui/material/styles';
import { IconButton, Box, Menu, MenuItem } from '@mui/material';
import { colors } from '../../constants';

export const Navbar = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  backgroundColor: colors.blueChipBg, // Using static color
  height: '100vh',
  maxHeight: '4rem',
  width: '100%',
  padding: '0 1rem',
  boxSizing: 'border-box',
  boxShadow: `0rem 0.25rem 1.25rem 0rem rgba(63, 115, 245, 0.1)`,
  position: 'relative'
}));

export const MenuButton = styled(IconButton)(() => ({
  position: 'absolute',
  left: '1rem',
  color: colors.blueDarkText, // Using static color
  border: `2px solid ${colors.blueBase}`, // Using static color
  borderRadius: '0.5rem',
  padding: '0.15rem'
}));

export const AdminInfo = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  marginRight: '1rem',
  minHeight: '4rem'
}));

export const AdminRole = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'flex-end',
  color: colors.grayBody // Using static color
}));

export const AdminName = styled('div')(() => ({
  fontWeight: 400,
  color: colors.grayMedium // Using static color
}));

export const ProfileImageWrapper = styled(Box)(({ theme }) => ({
  aspectRatio: '1',
  borderRadius: '50%',
  overflow: 'hidden',
  border: `0.05rem solid ${colors.greyDisabled}`, // Using static color
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '2.5rem',
  height: '2.5rem',

  [theme.breakpoints.down('md')]: {
    width: '2.5rem',
    height: '2.5rem'
  },

  [theme.breakpoints.down('sm')]: {
    width: '2rem',
    height: '2rem'
  }
}));

export const DrawerStyle = {
  '& .MuiDrawer-paper': {
    width: 240,
    overflowY: 'hidden',
    '&::-webkit-scrollbar': {
      display: 'none'
    }
  }
};

export const StyledMenu = styled(Menu)(({ theme }) => ({
  '& .MuiPaper-root': {
    marginTop: theme.spacing(1),
    borderRadius: 5,
    boxShadow: `0px 8px 24px rgba(0,0,0,0.12) !important`,
    padding: theme.spacing(0.5),
    maxHeight: 400,
    width: 300,
    overflowY: 'auto',
    backgroundColor: '#fff',
    zIndex: 1302
  }
}));

export const StyledMenuItem = styled(MenuItem)(() => ({
  display: 'flex',
  alignItems: 'center',
  borderRadius: 5,
  margin: '12px 12px',
  padding: '12px 18px',
  backgroundColor: '#fff',

  transition: 'all 0.2s ease',
  border: '1px solid transparent',

  '&:hover': {
    backgroundColor: 'rgba(0, 102, 255, 0.06)'
  },

  '&.Mui-selected': {
    border: `1.5px solid ${colors.blueBase}`,
    backgroundColor: '#f9fbff',
    color: colors.blueBase,
    fontWeight: 600,
    boxShadow: '6px 5px 17px rgb(0 102 255 / 10%)'
  },

  '&.MuiMenuItem-root': {
    boxShadow: '6px 5px 17px #c3d4fc7a'
  },

  '& .MuiListItemIcon-root': {
    minWidth: 40,
    display: 'flex',
    justifyContent: 'center'
  },

  '& .MuiTypography-root': {
    fontWeight: 600,
    fontSize: 15
  }
}));
